import { render, staticRenderFns } from "./WarehousesCharges.vue?vue&type=template&id=64809a0a&scoped=true"
import script from "./WarehousesCharges.vue?vue&type=script&lang=js"
export * from "./WarehousesCharges.vue?vue&type=script&lang=js"
import style0 from "./WarehousesCharges.vue?vue&type=style&index=0&id=64809a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64809a0a",
  null
  
)

export default component.exports